import { styled } from '@mui/material';

import { UserSimulationWidget } from '../UserSimulationWidget';

const Section = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const AISimulationSection = () => (
  <Section>
    <UserSimulationWidget />
  </Section>
);
